// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginWelcome_loginContainer__mPRtE","copy":"LoginWelcome_copy__1jEt4"};